import { inject, Injectable } from "@angular/core";
import { AuthHttpClient } from "../auth/auth-client.service";
import { environment } from "../../../environments/environment";
import { Anwsers, SurveyDto, SurveyStatus } from "@libs/shares/dto/survey.dto";
import { type forms_v1 } from "@googleapis/forms";
import { BehaviorSubject, firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SurveyService {
  private authHttpClient = inject(AuthHttpClient);

  requiredSurveysForLoggedInUser$ = new BehaviorSubject<{ formId: string; createdAt: Date }[] | undefined>(undefined);
  async sendResponses(orgId: string, formId: string, surveyData: SurveyDto) {
    await firstValueFrom(this.authHttpClient.post(`${environment.apiBaseUrl}/surveys/${orgId}/${formId}`, surveyData));
    if (surveyData.status === SurveyStatus.completed) {
      this.requiredSurveysForLoggedInUser$.next(
        this.requiredSurveysForLoggedInUser$.value?.filter((survey) => survey.formId !== formId)
      );
    }
  }

  getFormById(orgId: string, formId: string) {
    return this.authHttpClient.get<{
      info: forms_v1.Schema$Info | undefined;
      items: forms_v1.Schema$Item[] | undefined;
      formData: Anwsers | null;
    }>(`${environment.apiBaseUrl}/surveys/${orgId}/${formId}`);
  }

  async getIncompleteSurveysByOrgId(orgId: string) {
    return firstValueFrom(
      this.authHttpClient.get<
        {
          formId: string;
          createdAt: Date;
          surveyStatus: SurveyStatus;
        }[]
      >(`${environment.apiBaseUrl}/surveys/${orgId}/?status=incomplete`)
    );
  }
}
